import React, { useContext, useState } from 'react';
import {
    CircularProgress,
    Grid,
    IconButton,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    withStyles
} from '@material-ui/core';
import { TCaredDashboardContext, TCaredDashboardProvider } from './tCaredDashboard-Provider';
import RemoveIcon from '@material-ui/icons/Remove';
import LockIcon from '@material-ui/icons/Lock';
import TodayIcon from '@material-ui/icons/Today';
import Tooltip from '@material-ui/core/Tooltip';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import moment from 'moment';
import TCardDashboardModal from './T-cardModal';
import TCardsCloseDay from './TCardsCloseDay';
import AddUpdateHoliday from '../Calendar/AddUpdateHoliday';
import { AppStorage } from '../../../../Core/Service/storage-service';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';
import TcardMapList from './TcardTemplates/TcardMapList';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import formatters from '../../../../Core/Grid/inputFormatter';
import CachedIcon from '@material-ui/icons/Cached';
import WeekDaysHeader from './TcardTemplates/weekdaysHeader';
import { Tcard } from './TcardTemplates/mainTcard';
import { HeadingTableCell, StyledTableCell } from './TcardTemplates/tableStyle';
import HolidayRow from './TcardTemplates/tcardHoliday';
import WeekdaysList from './TcardTemplates/weekDaysList';
import { createLogger } from '@microsoft/signalr/dist/esm/Utils';

const useStyles = makeStyles({
    table: {
        width: '99.7%'
    },

    badgecss: {
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            padding: '0 !important'
            // background: 'red'
        }
    },

    colHeight: {
        overflowY: 'auto',
        verticalAlign: 'baseline'
    },
    Tcard: {
        cursor: 'pointer',
        padding: 3,
        border: '1px solid rgba(0,0,0,0.1)',
        position: 'relative',
        '&:hover': {
            border: '1px solid rgba(0,0,0,0.9)'
        }
    },
    editButton: {
        position: 'absolute',
        top: 5,
        right: 5,
        opacity: 0,
        transition: 'opacity 0.3s ease-in-out',
        background: 'white'
    },
    draggingOver: {
        backgroundColor: 'rgba(0, 0, 0, 0.12) !important'
    },
    noRecordFound: {
        height: '46px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '11px',
        border: '1px dotted rgba(0, 0, 0, 0.05)'
    }
});

const CardDash = (props) => {
    const {
        fullScreen,
        loader,
        tCardList,
        legendItems,
        handleCustomerFilter,
        handleRegNoFilter,
        handleFullScreen,
        checkIsTcardReadonly,
        history,
        handleCurrentWeek,
        reset,
        handleChange,
        branchList,
        curretDate,
        handlePlusButtonClick,
        submitTcardLock,
        changeWeek,
        count,
        handleDragEnd,
        updatedStatus,
        toBeScheduledCards,
        portalSetting,
        expand,
        handleExpand,
        handleTcardOpen,
        handleCalendarButtonClick,
        handleMOT,
        openModal,
        closeDayModal,
        setCloseDayModal,
        selectedDate,
        handleCloseDayModal,
        temp,
        ShowAllTcards,
        userHolidayModal,
        setUserHolidayModal,
        handleUserHolidayModal,
        motClose,
        handleCloseMOT,
        motFields,
        submitMotClose,
        filters,
        dayFull,
        handletSetDayFull,
        handletOpenDayFull,
        handletCloseSetDayFull,
        workType,
        shortListByTrailter,
        setMotColor
    } = useContext(TCaredDashboardContext);
    const classes = useStyles();

    const firstColumn = [];
    const secondColumn = [];
    const thirdColumn = [];

    updatedStatus.flat().forEach((item) => {
        const [col, row] = item.tCardStatusequence.split('-').map(Number);

        const objWithRow = { ...item, row };

        if (col === 1) {
            firstColumn.push(objWithRow);
        } else if (col === 2) {
            secondColumn.push(objWithRow);
        } else if (col === 3) {
            thirdColumn.push(objWithRow);
        }
    });

    // Sort by row sequence
    firstColumn.sort((a, b) => a.row - b.row);
    secondColumn.sort((a, b) => a.row - b.row);
    thirdColumn.sort((a, b) => a.row - b.row);

    return (
        <div
            className={` custom-scroll`}
            style={{
                position: !fullScreen ? 'static' : 'fixed',
                top: 0,
                left: 0,
                width: !fullScreen ? '100%' : '100vw',
                height: !fullScreen ? '100%' : '100vh',
                background: 'white',
                zIndex: 1000,
                overflowY: 'auto'
            }}
        >
            <TableContainer style={{ height: 'calc(100vh - 110px)' }}>
                {loader ? (
                    <div style={{ marginTop: 30, width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Table className={classes.table} aria-label="simple table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={3 + tCardList.closeDays?.length}>
                                    <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                                        <Grid item>
                                            <Grid container spacing={1}>
                                                {legendItems.map((item, index) => (
                                                    <>
                                                        <Grid item key={index}>
                                                            <div
                                                                style={{
                                                                    fontSize: 10,
                                                                    fontWeight: 800,
                                                                    background: item.background,
                                                                    color: item.color,
                                                                    padding: '1px 6px',
                                                                    // borderRadius: '4px',
                                                                    textAlign: 'center',
                                                                    minWidth: '30px',
                                                                    marginLeft: 10
                                                                }}
                                                            >
                                                                {item.label}
                                                            </div>
                                                        </Grid>
                                                    </>
                                                ))}
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
                                                <Grid item>
                                                    <input onChange={handleCustomerFilter} placeholder="Search customer" value={filters.cust} name="cust" />
                                                </Grid>
                                                <Grid item>
                                                    <input onChange={handleRegNoFilter} placeholder="Search Reg No." value={filters.regNo} name="regNo" />
                                                </Grid>
                                                {!fullScreen ? (
                                                    <abbr title="FullScreen">
                                                        <FullscreenIcon style={{ fontSize: 30, cursor: 'pointer', marginTop: 5 }} onClick={handleFullScreen} />
                                                    </abbr>
                                                ) : (
                                                    <abbr title="Normal view">
                                                        <FullscreenExitIcon
                                                            style={{ fontSize: 30, cursor: 'pointer', marginTop: 5 }}
                                                            onClick={handleFullScreen}
                                                        />
                                                    </abbr>
                                                )}
                                                {!checkIsTcardReadonly && (
                                                    <Grid item>
                                                        {' '}
                                                        <div
                                                            onClick={() => history.push('/CheckInDashboard?branchID=' + tCardList.branchID)}
                                                            style={{
                                                                color: 'white',
                                                                fontSize: 11,
                                                                z: 'green',
                                                                padding: '0px 8px',
                                                                cursor: 'pointer'
                                                            }}
                                                            size="small"
                                                        >
                                                            Create T-Card
                                                        </div>
                                                    </Grid>
                                                )}

                                                <Grid item>
                                                    <div
                                                        onClick={handleCurrentWeek}
                                                        style={{
                                                            color: 'white',
                                                            fontSize: 11,
                                                            background: 'green',
                                                            padding: '0px 8px',
                                                            cursor: 'pointer'
                                                        }}
                                                        size="small"
                                                    >
                                                        Current Week
                                                    </div>
                                                </Grid>
                                                <abbr title="Reset Dates">
                                                    <RotateLeftIcon style={{ fontSize: 30, cursor: 'pointer', marginTop: 5 }} onClick={reset} />
                                                </abbr>
                                                <Grid item>
                                                    {' '}
                                                    <select onChange={handleChange} value={tCardList.branchID}>
                                                        {branchList.map((btn, i) => {
                                                            return (
                                                                <option key={i} value={btn.id}>
                                                                    {btn.name}{' '}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <TableBody>
                                <TableRow>
                                    <HeadingTableCell align="center" rowSpan={2} style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}>
                                        <TcardMapList
                                            List={firstColumn}
                                            tCardList={tCardList}
                                            toBeScheduledCards={toBeScheduledCards}
                                            classes={classes}
                                            portalSetting={portalSetting}
                                            expand={expand}
                                            handleExpand={handleExpand}
                                            handleTcardOpen={handleTcardOpen}
                                            legendItems={legendItems}
                                            Tcard={Tcard}
                                            checkIsTcardReadonly={checkIsTcardReadonly}
                                        />
                                    </HeadingTableCell>
                                    <HeadingTableCell align="center" rowSpan={2} style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}>
                                        <TcardMapList
                                            List={secondColumn}
                                            tCardList={tCardList}
                                            toBeScheduledCards={toBeScheduledCards}
                                            classes={classes}
                                            portalSetting={portalSetting}
                                            expand={expand}
                                            handleExpand={handleExpand}
                                            handleTcardOpen={handleTcardOpen}
                                            legendItems={legendItems}
                                            Tcard={Tcard}
                                            checkIsTcardReadonly={checkIsTcardReadonly}
                                        />
                                    </HeadingTableCell>
                                    <HeadingTableCell align="center" rowSpan={2} style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}>
                                        <TcardMapList
                                            List={thirdColumn}
                                            tCardList={tCardList}
                                            toBeScheduledCards={toBeScheduledCards}
                                            classes={classes}
                                            portalSetting={portalSetting}
                                            expand={expand}
                                            handleExpand={handleExpand}
                                            handleTcardOpen={handleTcardOpen}
                                            legendItems={legendItems}
                                            Tcard={Tcard}
                                            checkIsTcardReadonly={checkIsTcardReadonly}
                                        />
                                    </HeadingTableCell>

                                    {tCardList.closeDays.map(({ dt, date, dayfull, tCardCalendarID }, index) => {
                                        let hours = tCardList.allocatedHours.find(
                                            (k) => moment(k.tCardsBookingDate).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD')
                                        );

                                        let closeDayStatus = tCardList.bookingConfirmed.filter(
                                            (rw) => moment(rw.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD')
                                        );

                                        let bkList = closeDayStatus.filter((j) => j.status === 'BOOKING CONFIRMED');

                                        let iscloseDay = bkList.length === 0;

                                        let isToday = moment(dt).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');

                                        return (
                                            <WeekDaysHeader
                                                index={index}
                                                tCardList={tCardList}
                                                isToday={isToday}
                                                dt={dt}
                                                curretDate={curretDate}
                                                iscloseDay={iscloseDay}
                                                handlePlusButtonClick={handlePlusButtonClick}
                                                tCardCalendarID={tCardCalendarID}
                                                dayfull={dayfull}
                                                hours={hours}
                                                handletSetDayFull={handletSetDayFull}
                                                changeWeek={changeWeek}
                                                count={count}
                                            />
                                        );
                                    })}
                                </TableRow>
                                <TableRow>
                                    <StyledTableCell
                                        align="center"
                                        colSpan={tCardList.closeDays.length}
                                        rowSpan={updatedStatus.length + 2}
                                        style={{ padding: 0 }}
                                        width={`${tCardList.calculateWidth + tCardList.calculateWidth - 100}}`}
                                    >
                                        <Table>
                                            <TableBody>
                                                {/* Holiday */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt }, index) => (
                                                        <HolidayRow tCardList={tCardList} handleCalendarButtonClick={handleCalendarButtonClick} dt={dt} />
                                                    ))}
                                                </TableRow>
                                                {/* Day */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const dayCards = tCardList.bookingConfirmed.filter(
                                                            (m) =>
                                                                moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') &&
                                                                !m.cd &&
                                                                !m.ns &&
                                                                m.status === 'BOOKING CONFIRMED'
                                                        );

                                                        return (
                                                            <WeekdaysList
                                                                label={'Day Shift'}
                                                                index={index}
                                                                isShowCount="true"
                                                                countList={tCardList.allocatedHours}
                                                                dt={dt}
                                                                mainCardList={dayCards}
                                                                isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                mainHead={true}
                                                                droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-ds`}
                                                                countKey={'dayAllocatedHours'}
                                                            />
                                                        );
                                                    })}
                                                </TableRow>

                                                {/* Collection and Delivery */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const cdCards = tCardList.bookingConfirmed.filter(
                                                            (m) =>
                                                                moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') &&
                                                                m.cd &&
                                                                !m.ns &&
                                                                m.status === 'BOOKING CONFIRMED'
                                                        );
                                                        return (
                                                            <>
                                                                <WeekdaysList
                                                                    label={'Collection and Delivery'}
                                                                    index={index}
                                                                    dt={dt}
                                                                    mainCardList={cdCards}
                                                                    isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                    droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-cd`}
                                                                />
                                                            </>
                                                        );
                                                    })}
                                                </TableRow>
                                                {/* MOT */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, motclosed, tCardCalendarID }, index) => {
                                                        const motCards = tCardList.bookingConfirmed.filter(
                                                            (m) =>
                                                                moment(m.motdate).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') &&
                                                                m.mot &&
                                                                m.status !== 'COLLECTED'
                                                        );

                                                        return (
                                                            <StyledTableCell align="center" key={index}>
                                                                <div style={{ background: motclosed ? 'LightGray' : '', height: '100%' }}>
                                                                    <div style={{ background: motclosed ? 'LightGray' : 'lightgrey' }}>
                                                                        <Typography
                                                                            style={{
                                                                                textAlign: 'center',
                                                                                fontWeight: 700,
                                                                                textTransform: 'uppercase',
                                                                                fontSize: 12,
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={() => handleMOT(dt, motclosed, tCardCalendarID)}
                                                                        >
                                                                            MOT
                                                                        </Typography>
                                                                    </div>
                                                                    <div className={`${classes.colHeight} custom-scroll`}>
                                                                        {motCards.length === 0 ? (
                                                                            <div className={classes.noRecordFound}>
                                                                                <span
                                                                                    style={{
                                                                                        color: motclosed ? 'red' : '',
                                                                                        fontWeight: motclosed ? '600' : 'normal'
                                                                                    }}
                                                                                >
                                                                                    {' '}
                                                                                    {motclosed ? 'MOT is Closed' : 'No Record Found'}
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            motCards.map((k) => (
                                                                                <div key={k.tCardsID}>
                                                                                    <Tcard
                                                                                        legendItems={legendItems}
                                                                                        days={k.days}
                                                                                        handleTcardOpen={handleTcardOpen}
                                                                                        date={k.bd}
                                                                                        customer={k.cust}
                                                                                        isLoanVehicle={k.loanVehicle}
                                                                                        registration={k.reg}
                                                                                        color={setMotColor(k.motWorkType, false)}
                                                                                        textColor={setMotColor(k.motWorkType, true)}
                                                                                        tCardsID={k.tCardsID}
                                                                                        wn={k.wn}
                                                                                        vsc={k.vsc}
                                                                                        breakdown={k.breakdown}
                                                                                        breakdownStatus={k.breakdownStatus}
                                                                                        breakdownTime={k.breakdownTime}
                                                                                        status={{
                                                                                            recall: k.recall,
                                                                                            tacho: k.tacho,
                                                                                            motdate: k.motdate,
                                                                                            motloc: k.motloc,
                                                                                            mot: k.mot,
                                                                                            repair: k.repair,
                                                                                            inspection: k.inspection,
                                                                                            cd: k.cd,
                                                                                            waiting: k.waiting,
                                                                                            service: k.service,
                                                                                            ns: k.ns
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            ))
                                                                        )}
                                                                    </div>
                                                                </div>{' '}
                                                            </StyledTableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                                {/* Night Shift */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const nightShiftCards = tCardList.bookingConfirmed.filter(
                                                            (m) => moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') && m.ns && !m.cd
                                                        );

                                                        return (
                                                            <>
                                                                <WeekdaysList
                                                                    label={'Night Shift'}
                                                                    index={index}
                                                                    isShowCount="true"
                                                                    countList={tCardList.allocatedHours}
                                                                    countKey={'nightAllocatedHours'}
                                                                    dt={dt}
                                                                    mainCardList={nightShiftCards}
                                                                    isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                    mainHead={true}
                                                                    droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-ns`}
                                                                />
                                                            </>
                                                        );
                                                    })}
                                                </TableRow>
                                                {/* Collection and Delivery Night Shift */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const collectionDeliveryCards = tCardList.bookingConfirmed.filter(
                                                            (m) => moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') && m.cd && m.ns
                                                        );

                                                        return (
                                                            <>
                                                                <WeekdaysList
                                                                    label={'Collection and Delivery'}
                                                                    index={index}
                                                                    dt={dt}
                                                                    mainCardList={collectionDeliveryCards}
                                                                    isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                    droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-cd-ns`}
                                                                    ShowSat={true}
                                                                />
                                                            </>
                                                        );
                                                    })}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </StyledTableCell>
                                </TableRow>
                            </TableBody>
                        </DragDropContext>
                    </Table>
                )}
            </TableContainer>

            {/* ///Modals */}

            {dayFull.show ? (
                <DialogComp title="Warning" onClose={handletCloseSetDayFull} maxWidth="sm">
                    <ConfirmationModal
                        message={
                            dayFull.mode == 'set'
                                ? `Do you want to set ${formatters.MonthShortFormatter(dayFull.date)} as full? No further bookings will be allowed on the day`
                                : `Are you sure to open ${formatters.MonthShortFormatter(dayFull.date)} for bookings?`
                        }
                        handleSubmit={submitTcardLock}
                        handleCancel={handletCloseSetDayFull}
                    />
                </DialogComp>
            ) : null}

            {openModal ? <TCardDashboardModal id={tCardList.tCardID} onClose={handleTcardOpen} tCardSelectedColor={tCardList?.tCardSelectedColor} /> : null}
            {closeDayModal ? (
                <DialogComp title="Close Day" onClose={() => setCloseDayModal(false)} maxWidth="xs" fullWidth>
                    <TCardsCloseDay calID={selectedDate} onClose={handleCloseDayModal} />
                </DialogComp>
            ) : null}
            {temp.open ? (
                <DialogComp title={temp.name} onClose={() => ShowAllTcards(false, '', [])} maxWidth="xs" fullWidth>
                    <div onClick={() => ShowAllTcards(false, '', [])} style={{ height: '500px', overflowY: 'auto' }}>
                        {temp.list?.map((k) => {
                            return (
                                <Tcard
                                    legendItems={legendItems}
                                    handleTcardOpen={handleTcardOpen}
                                    days={k.days}
                                    date={k.bd}
                                    customer={k.cust}
                                    isLoanVehicle={k.loanVehicle}
                                    registration={k.reg}
                                    textColor={k.tc}
                                    color={k.bgc}
                                    tCardsID={k.tCardsID}
                                    wn={k.wn}
                                    vsc={k.vsc}
                                    breakdown={k.breakdown}
                                    breakdownStatus={k.breakdownStatus}
                                    breakdownTime={k.breakdownTime}
                                    status={{
                                        recall: k.recall,
                                        tacho: k.tacho,
                                        mot: k.mot,
                                        repair: k.repair,
                                        inspection: k.inspection,
                                        cd: k.cd,
                                        waiting: k.waiting,
                                        service: k.service,
                                        ns: k.ns
                                    }}
                                />
                            );
                        })}
                    </div>
                </DialogComp>
            ) : null}
            {userHolidayModal ? (
                <DialogComp title="Add User Holiday" onClose={() => setUserHolidayModal(false)} maxWidth="md" fullWidth>
                    <AddUpdateHoliday selectedDate={selectedDate} onClose={handleUserHolidayModal} branchID={tCardList.branchID} />
                </DialogComp>
            ) : null}

            {motClose ? (
                <DialogComp title="Warning" onClose={handleCloseMOT} maxWidth="sm">
                    <ConfirmationModal message={motFields.motMessage} handleSubmit={submitMotClose} handleCancel={handleCloseMOT} />
                </DialogComp>
            ) : null}
        </div>
    );
};

const TcardDashboard = (props) => {
    return (
        <TCaredDashboardProvider {...props}>
            <CardDash {...props} />
        </TCaredDashboardProvider>
    );
};
export default TcardDashboard;
